module.exports = __webpack_public_path__ + "media/images/logos/microsoft-2f68151aad7319ba4a6923d325f15572.png";